import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "@/components/useTranslation";

export default function Navbar() {
  const router = useRouter();
  const t = useTranslation();

  return (
    <>
      <nav style={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        width: "100%",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }}>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1280px",
          padding: "12px 16px",
          margin: "0 auto"
        }}>
          {/* Logo */}
          <Link href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
            <img
              src="/resenas.png"
              alt="Resenas123 Logo"
              style={{ height: "50px", width: "auto" }}
            />
          </Link>

          {/* Navigation Links */}
          <ul style={{
            display: "flex",
            gap: "32px",
            listStyle: "none",
            margin: 0,
            padding: 0,
            alignItems: "center"
          }}>
            <li>
              <Link
                href="/"
                style={{
                  color: "#111827",
                  textDecoration: "none",
                  fontWeight: 500,
                  padding: "8px 0",
                  transition: "color 0.2s"
                }}
                onMouseOver={(e) => e.target.style.color = "#2563eb"}
                onMouseOut={(e) => e.target.style.color = "#111827"}
              >
                {t.home}
              </Link>
            </li>
            <li>
              <Link
                href="/#preise"
                style={{
                  color: "#111827",
                  textDecoration: "none",
                  fontWeight: 500,
                  padding: "8px 0",
                  transition: "color 0.2s"
                }}
                onMouseOver={(e) => e.target.style.color = "#2563eb"}
                onMouseOut={(e) => e.target.style.color = "#111827"}
              >
                {t.services}
              </Link>
            </li>
            <li>
              <Link
                href="/#preise"
                style={{
                  color: "#111827",
                  textDecoration: "none",
                  fontWeight: 500,
                  padding: "8px 0",
                  transition: "color 0.2s"
                }}
                onMouseOver={(e) => e.target.style.color = "#2563eb"}
                onMouseOut={(e) => e.target.style.color = "#111827"}
              >
                {t.price}
              </Link>
            </li>
          </ul>

          {/* Right Side - Contact & Language */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "16px"
          }}>
            {/* Email */}
            <a
              href="mailto:info@resenas123.es"
              style={{
                color: "#1d4ed8",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "14px"
              }}
            >
              info@resenas123.es
            </a>

            {/* Language Selector */}
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Link href="/" locale="fr">
                <img src="/images/global/flag/france.png" alt="Français" style={{ width: "24px", height: "24px", cursor: "pointer" }} />
              </Link>
              <Link href="/" locale="de">
                <img src="/images/global/flag/germany.png" alt="Deutsch" style={{ width: "24px", height: "24px", cursor: "pointer" }} />
              </Link>
              <Link href="/" locale="es">
                <img src="/images/global/flag/spain.png" alt="Español" style={{ width: "24px", height: "24px", cursor: "pointer" }} />
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
